/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Infra API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  InfraHostAgentV7Response,
  InfraHostDiskV7Response,
  InfraHostInstallPackageV7Response,
  InfraHostNetworkV7Response,
  InfraHostProcessV7Response,
  InfraHostRelationV7Response,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 호스트 에이전트 정보
 */
export const getV7InfraHostsAgentByHostId = (
  hostId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  hostId = unref(hostId);

  return customAxiosInstance<InfraHostAgentV7Response>(
    { url: `/api/v7/infra/hosts/${hostId}/agent`, method: 'GET', signal },
    options,
  );
};

export const getGetV7InfraHostsAgentByHostIdQueryKey = (hostId?: MaybeRef<string>) => {
  return ['api', 'v7', 'infra', 'hosts', hostId, 'agent'] as const;
};

export const getGetV7InfraHostsAgentByHostIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7InfraHostsAgentByHostId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7InfraHostsAgentByHostId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7InfraHostsAgentByHostIdQueryKey(hostId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7InfraHostsAgentByHostId>>> = ({
    signal,
  }) => getV7InfraHostsAgentByHostId(hostId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(hostId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7InfraHostsAgentByHostId>>, TError, TData>;
};

export type GetV7InfraHostsAgentByHostIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7InfraHostsAgentByHostId>>
>;
export type GetV7InfraHostsAgentByHostIdQueryError = ErrorType<unknown>;

/**
 * @summary 호스트 에이전트 정보
 */

export function useGetV7InfraHostsAgentByHostId<
  TData = Awaited<ReturnType<typeof getV7InfraHostsAgentByHostId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7InfraHostsAgentByHostId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7InfraHostsAgentByHostIdQueryOptions(hostId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 호스트 프로세스 목록 조회
 */
export const getV7InfraHostsAlertProcessByHostId = (
  hostId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  hostId = unref(hostId);

  return customAxiosInstance<InfraHostProcessV7Response>(
    { url: `/api/v7/infra/hosts/${hostId}/alert-process`, method: 'GET', signal },
    options,
  );
};

export const getGetV7InfraHostsAlertProcessByHostIdQueryKey = (hostId?: MaybeRef<string>) => {
  return ['api', 'v7', 'infra', 'hosts', hostId, 'alert-process'] as const;
};

export const getGetV7InfraHostsAlertProcessByHostIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7InfraHostsAlertProcessByHostId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7InfraHostsAlertProcessByHostId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7InfraHostsAlertProcessByHostIdQueryKey(hostId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7InfraHostsAlertProcessByHostId>>> = ({
    signal,
  }) => getV7InfraHostsAlertProcessByHostId(hostId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(hostId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7InfraHostsAlertProcessByHostId>>,
    TError,
    TData
  >;
};

export type GetV7InfraHostsAlertProcessByHostIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7InfraHostsAlertProcessByHostId>>
>;
export type GetV7InfraHostsAlertProcessByHostIdQueryError = ErrorType<unknown>;

/**
 * @summary 호스트 프로세스 목록 조회
 */

export function useGetV7InfraHostsAlertProcessByHostId<
  TData = Awaited<ReturnType<typeof getV7InfraHostsAlertProcessByHostId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7InfraHostsAlertProcessByHostId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7InfraHostsAlertProcessByHostIdQueryOptions(hostId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 호스트 디스크 정보 조회
 */
export const getV7InfraHostsDiskByHostId = (
  hostId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  hostId = unref(hostId);

  return customAxiosInstance<InfraHostDiskV7Response>(
    { url: `/api/v7/infra/hosts/${hostId}/disk`, method: 'GET', signal },
    options,
  );
};

export const getGetV7InfraHostsDiskByHostIdQueryKey = (hostId?: MaybeRef<string>) => {
  return ['api', 'v7', 'infra', 'hosts', hostId, 'disk'] as const;
};

export const getGetV7InfraHostsDiskByHostIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7InfraHostsDiskByHostId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7InfraHostsDiskByHostId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7InfraHostsDiskByHostIdQueryKey(hostId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7InfraHostsDiskByHostId>>> = ({
    signal,
  }) => getV7InfraHostsDiskByHostId(hostId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(hostId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7InfraHostsDiskByHostId>>, TError, TData>;
};

export type GetV7InfraHostsDiskByHostIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7InfraHostsDiskByHostId>>
>;
export type GetV7InfraHostsDiskByHostIdQueryError = ErrorType<unknown>;

/**
 * @summary 호스트 디스크 정보 조회
 */

export function useGetV7InfraHostsDiskByHostId<
  TData = Awaited<ReturnType<typeof getV7InfraHostsDiskByHostId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7InfraHostsDiskByHostId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7InfraHostsDiskByHostIdQueryOptions(hostId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 설치 패키지 정보 조회
 */
export const getV7InfraHostsInstallPackageByHostId = (
  hostId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  hostId = unref(hostId);

  return customAxiosInstance<InfraHostInstallPackageV7Response>(
    { url: `/api/v7/infra/hosts/${hostId}/install-package`, method: 'GET', signal },
    options,
  );
};

export const getGetV7InfraHostsInstallPackageByHostIdQueryKey = (hostId?: MaybeRef<string>) => {
  return ['api', 'v7', 'infra', 'hosts', hostId, 'install-package'] as const;
};

export const getGetV7InfraHostsInstallPackageByHostIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7InfraHostsInstallPackageByHostId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7InfraHostsInstallPackageByHostId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7InfraHostsInstallPackageByHostIdQueryKey(hostId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7InfraHostsInstallPackageByHostId>>
  > = ({ signal }) => getV7InfraHostsInstallPackageByHostId(hostId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(hostId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7InfraHostsInstallPackageByHostId>>,
    TError,
    TData
  >;
};

export type GetV7InfraHostsInstallPackageByHostIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7InfraHostsInstallPackageByHostId>>
>;
export type GetV7InfraHostsInstallPackageByHostIdQueryError = ErrorType<unknown>;

/**
 * @summary 설치 패키지 정보 조회
 */

export function useGetV7InfraHostsInstallPackageByHostId<
  TData = Awaited<ReturnType<typeof getV7InfraHostsInstallPackageByHostId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7InfraHostsInstallPackageByHostId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7InfraHostsInstallPackageByHostIdQueryOptions(hostId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 호스트 네트워크 정보 조회
 */
export const getV7InfraHostsNetworkByHostId = (
  hostId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  hostId = unref(hostId);

  return customAxiosInstance<InfraHostNetworkV7Response>(
    { url: `/api/v7/infra/hosts/${hostId}/network`, method: 'GET', signal },
    options,
  );
};

export const getGetV7InfraHostsNetworkByHostIdQueryKey = (hostId?: MaybeRef<string>) => {
  return ['api', 'v7', 'infra', 'hosts', hostId, 'network'] as const;
};

export const getGetV7InfraHostsNetworkByHostIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7InfraHostsNetworkByHostId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7InfraHostsNetworkByHostId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7InfraHostsNetworkByHostIdQueryKey(hostId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7InfraHostsNetworkByHostId>>> = ({
    signal,
  }) => getV7InfraHostsNetworkByHostId(hostId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(hostId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7InfraHostsNetworkByHostId>>, TError, TData>;
};

export type GetV7InfraHostsNetworkByHostIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7InfraHostsNetworkByHostId>>
>;
export type GetV7InfraHostsNetworkByHostIdQueryError = ErrorType<unknown>;

/**
 * @summary 호스트 네트워크 정보 조회
 */

export function useGetV7InfraHostsNetworkByHostId<
  TData = Awaited<ReturnType<typeof getV7InfraHostsNetworkByHostId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7InfraHostsNetworkByHostId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7InfraHostsNetworkByHostIdQueryOptions(hostId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 호스트 프로세스 목록 조회
 */
export const getV7InfraHostsProcessByHostId = (
  hostId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  hostId = unref(hostId);

  return customAxiosInstance<InfraHostProcessV7Response>(
    { url: `/api/v7/infra/hosts/${hostId}/process`, method: 'GET', signal },
    options,
  );
};

export const getGetV7InfraHostsProcessByHostIdQueryKey = (hostId?: MaybeRef<string>) => {
  return ['api', 'v7', 'infra', 'hosts', hostId, 'process'] as const;
};

export const getGetV7InfraHostsProcessByHostIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7InfraHostsProcessByHostId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7InfraHostsProcessByHostId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7InfraHostsProcessByHostIdQueryKey(hostId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7InfraHostsProcessByHostId>>> = ({
    signal,
  }) => getV7InfraHostsProcessByHostId(hostId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(hostId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7InfraHostsProcessByHostId>>, TError, TData>;
};

export type GetV7InfraHostsProcessByHostIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7InfraHostsProcessByHostId>>
>;
export type GetV7InfraHostsProcessByHostIdQueryError = ErrorType<unknown>;

/**
 * @summary 호스트 프로세스 목록 조회
 */

export function useGetV7InfraHostsProcessByHostId<
  TData = Awaited<ReturnType<typeof getV7InfraHostsProcessByHostId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7InfraHostsProcessByHostId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7InfraHostsProcessByHostIdQueryOptions(hostId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 호스트 관계 정보
 */
export const getV7InfraHostsRelationInfoByHostId = (
  hostId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  hostId = unref(hostId);

  return customAxiosInstance<InfraHostRelationV7Response>(
    { url: `/api/v7/infra/hosts/${hostId}/relation-info`, method: 'GET', signal },
    options,
  );
};

export const getGetV7InfraHostsRelationInfoByHostIdQueryKey = (hostId?: MaybeRef<string>) => {
  return ['api', 'v7', 'infra', 'hosts', hostId, 'relation-info'] as const;
};

export const getGetV7InfraHostsRelationInfoByHostIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7InfraHostsRelationInfoByHostId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7InfraHostsRelationInfoByHostId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7InfraHostsRelationInfoByHostIdQueryKey(hostId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7InfraHostsRelationInfoByHostId>>> = ({
    signal,
  }) => getV7InfraHostsRelationInfoByHostId(hostId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(hostId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7InfraHostsRelationInfoByHostId>>,
    TError,
    TData
  >;
};

export type GetV7InfraHostsRelationInfoByHostIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7InfraHostsRelationInfoByHostId>>
>;
export type GetV7InfraHostsRelationInfoByHostIdQueryError = ErrorType<unknown>;

/**
 * @summary 호스트 관계 정보
 */

export function useGetV7InfraHostsRelationInfoByHostId<
  TData = Awaited<ReturnType<typeof getV7InfraHostsRelationInfoByHostId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7InfraHostsRelationInfoByHostId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7InfraHostsRelationInfoByHostIdQueryOptions(hostId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
